import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import useAxios from 'axios-hooks'
import qs from 'qs'
import { useTranslation } from 'react-i18next'

import useDebounce from '../../hooks/useDebounce'

// material-ui
import MUIDataTable from "mui-datatables";
import { Box, FormControl, InputLabel, Input, FormHelperText, Tooltip, Typography} from '@material-ui/core'

const Search = ({ history, location }) => {
  const { t } = useTranslation()
  const parsedParams = qs.parse(location.search.substring(1))

  const [open, setOpen] = React.useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  const [searchForm, setSearchForm] = useState({
    searchQuery: location.state.searchQuery || ''
  })

  useEffect(() => {
    setSearchForm(prevState => ({ ...prevState, searchQuery: location.state.searchQuery }))
  }, [location.state.searchQuery])

  const debouncedSearchQuery = useDebounce(searchForm['searchQuery'], 250)

  const [{ data, loading, error }, executeAxios] = useAxios(
    {
      url: `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PREFIX}/search`,
      method: 'POST',
      withCredentials: true,
    },
    {manual: true}
  )

  useEffect(() => {
    debouncedSearchQuery.trim() !== '' &&
      executeAxios({
        data: {
          searchQuery: debouncedSearchQuery
        }
      })
  }, [debouncedSearchQuery])
 
  const handleInputChange = e => {
      const { name, value } = e.target
      setSearchForm(prevState => ({...prevState, [name]: value}))
  }
  
  const columns = [{ label: t('search.columns.title'), name: "title" }, {
    label: t('search.columns.introtext_snippet'),
    name: "introtext_snippet",
    options: {
      customBodyRender: value => <div dangerouslySetInnerHTML={{ __html: value}}/>
    }
  }]

  const options = {
    selectableRows: 'none',
    onRowClick: (rowData, rowMeta) => {
      console.log(rowData, rowMeta)
      return history.push({pathname: `/content/${data[rowMeta.rowIndex].id}`})
    },
    search: false,
    filter: false,
    print: false,
    //localization
    textLabels: {
      body: {
        noMatch: t('muitable.body.noMatch'),
        toolTip: "Sort",
        columnHeaderTooltip: column => t('muitable.tableHead.sortBy', { label: column.label }),
      },
      pagination: {
        next: t('muitable.footer.nextPage'),
        previous: t('muitable.footer.previousPage'),
        rowsPerPage: t('muitable.footer.rowsPerPage'),
        displayRows: t('muitable.footer.of'),
      },
      toolbar: {
        search: "Search",
        downloadCsv: "Download CSV",
        print: "Print",
        viewColumns: "View Columns",
        filterTable: "Filter Table",
      },
      filter: {
        all: "All",
        title: "FILTERS",
        reset: "RESET",
      },
      viewColumns: {
        title: "Show Columns",
        titleAria: "Show/Hide Table Columns",
      },
      selectedRows: {
        text: "row(s) selected",
        delete: "Delete",
        deleteAria: "Delete Selected Rows",
      },
    }
  }

  return (
    <Box>
      <FormControl>
        <InputLabel htmlFor="my-input">{t('search.form.label')}</InputLabel>
          <Tooltip
            PopperProps={{
              disablePortal: true,
            }}
            onClose={handleTooltipClose}
            open={open}
            disableFocusListener
            disableHoverListener
            disableTouchListener
            placement="right"
            title={
              <>
                <Typography color="inherit">{t('search.form.helperProperties.help')}</Typography>
                <p>{t('search.form.helperProperties.quotationMarks')}</p>
                <p>{t('search.form.helperProperties.asterisk')}</p>
              </>
            }
          >
            <Input id="searchQuery" name="searchQuery" type="text" value={searchForm.searchQuery} placeholder={t('search.form.placeholder')} onChange={handleInputChange} onFocus={handleTooltipOpen} onBlur={handleTooltipClose} autoComplete="off"/>
          </Tooltip>
        <FormHelperText>{t('search.form.helperText')}</FormHelperText>
      </FormControl>
      <MUIDataTable
        title={t('search.form.resultsTitle')}
        data={data}
        columns={columns}
        options={options}
      />
    </Box>
  )
}

Search.propTypes = {
}

export default Search
